import React from 'react';

import { Theme, withStyles } from '@material-ui/core/styles';

const styles = (theme: Theme) => ({
  toolbar: theme.mixins.toolbar,
  toolbarWithLinks: {
    // TODO: Refactor to dynamically calculate the height of the bar with links
    // This requires moving the patient-app Header into a module that accepts a ref
    // Current limitation: The current MUI AppBar lacks ref prop support, and adding changes dealing with refs in the App.tsx file could break existing pages
    // https://www.figma.com/design/9v0wqs4KtnOVtTD7QdCI1H/Digital-Forms-1.2?node-id=15027-637983&node-type=frame&t=qdFyCvRrKkWq4nZm-0
    minHeight: 35,
  },
});

interface HeaderGapProps {
  classes: {
    toolbar: string;
    toolbarWithLinks: string;
  };
  includeBarWithLinks?: boolean;
}

const HeaderGap: React.FC<HeaderGapProps> = ({ classes, includeBarWithLinks }) => (
  <>
    <div className={classes.toolbar} />
    {includeBarWithLinks && <div className={classes.toolbarWithLinks} />}
  </>
);

export default withStyles(styles)(HeaderGap);
